import type { Notification } from '@leoclinic/types';
import { getSupabaseClient } from '../supabase/client';

export class NotificationService {
  async listForProfile(profileId: string, limit = 20): Promise<Notification[]> {
    const supabase = getSupabaseClient();
    const { data, error } = await supabase
      .from('notifications')
      .select('*')
      .eq('profile_id', profileId)
      .order('created_at', { ascending: false })
      .limit(limit);
    if (error) throw error;
    return data ?? [];
  }

  async unreadCount(profileId: string): Promise<number> {
    const supabase = getSupabaseClient();
    const { count, error } = await supabase
      .from('notifications')
      .select('id', { count: 'exact', head: true })
      .eq('profile_id', profileId)
      .eq('is_read', false);
    if (error) throw error;
    return count ?? 0;
  }

  async markRead(id: string): Promise<void> {
    const supabase = getSupabaseClient();
    const { error } = await supabase.from('notifications').update({ is_read: true }).eq('id', id);
    if (error) throw error;
  }

  async markAllRead(profileId: string): Promise<void> {
    const supabase = getSupabaseClient();
    const { error } = await supabase
      .from('notifications')
      .update({ is_read: true })
      .eq('profile_id', profileId)
      .eq('is_read', false);
    if (error) throw error;
  }

  async create(
    clinicId: string,
    profileId: string,
    title: string,
    body?: string,
    channel: Notification['channel'] = 'in_app',
  ): Promise<Notification> {
    const supabase = getSupabaseClient();
    const { data, error } = await supabase
      .from('notifications')
      .insert({
        clinic_id: clinicId,
        profile_id: profileId,
        title,
        body: body ?? null,
        channel,
      })
      .select()
      .single();
    if (error) throw error;
    return data;
  }
}

export const notificationService = new NotificationService();
